import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SupportIcon from "@styles/all-images/icons/support.svg";
import DragIcon from "@styles/all-images/icons/drag-vertical.svg";
import ChatIcon from "@styles/all-images/icons/live-chat.svg";
import RightArrowIcon from "@styles/all-images/icons/right-arrow-blue.svg";
import DocumentsIcon from "@styles/all-images/icons/document-text.svg";
import EuroIcon from "@styles/all-images/icons/euro.svg";
import UsdIcon from "@styles/all-images/icons/usd.svg";
import LinkIcon from "@styles/all-images/icons/link.svg";
import ClientIcon from "@styles/all-images/icons/chart-combo-stacked.svg";
import idwalaIcon from "@styles/all-images/icons/idwala.svg";
import tegmulIcon from "@styles/all-images/icons/tegmul.svg";
import fuelcapIcon from "@styles/all-images/icons/fuelcap.svg";
import greencheck from "@styles/all-images/icons/greencheck.svg";
import ProfileImage from "@styles/all-images/icons/profile-icon.svg";
import PhoneIcon from "@styles/all-images/icons/phone-icon.svg";
import EmailIcon from "@styles/all-images/icons/envelope-icon.svg";
import MessageIcon from "@styles/all-images/icons/live-chat-small.svg";
import ClientIcon1 from "@styles/all-images/icons/client-icon/client-1.png";
import ClientIcon2 from "@styles/all-images/icons/client-icon/client-2.png";
import ClientIcon3 from "@styles/all-images/icons/client-icon/client-3.png";
import PhoneBlueIcon from "@styles/all-images/icons/phoneblue.svg";
import EmailBlueIcon from "@styles/all-images/icons/emailblue.svg";

import { Tabs, Tab, styled } from "@mui/material";
import actionsHandler from "@/store/actions/actionHandler";
import { useDispatch, useSelector } from "react-redux";
import { AppThunkDispatch, RootState } from "@/store";
import { UserManagementStatus } from "@/constants/enums/user-management-status.enum";
import { UserTierType } from "@/constants/enums/user-tier-type.enum";
import { ProfileApprovalStatus } from "@/constants/enums/approval-status.enum";

const StyledTabs = styled(Tabs)({
  minHeight: "unset",
  "& .MuiTabs-indicator": {
    display: "none",
  },
});

const StyledTab = styled(Tab)({
  minHeight: "unset",
  padding: "8px 16px",
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 600,
  minWidth: "unset",
});

const Dashboard = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(0);

  const [selectedCompany, setSelectedCompany] = useState(
    "Tegmul Fabrication Pty Ltd.",
  );

  const companies = [
    { name: "Idwala Energy Pty Ltd.", icon: idwalaIcon },
    { name: "Tegmul Fabrication Pty Ltd.", icon: tegmulIcon },
    { name: "FuelCap Pty Ltd.", icon: fuelcapIcon },
  ];

  const dispatch = useDispatch<AppThunkDispatch>();
  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { authenticatedCall } = actionsHandler("userProfileDetail");
        let id = JSON.parse(localStorage.getItem("user") || "{}").id;
        const response = await dispatch(
          authenticatedCall({
            method: "get",
          }),
        );
        if (response.ok) {
          setUserData(response.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, [dispatch]);
  const getTabClassName = (isActive: boolean) => {
    return `tw-text-sm tw-font-semibold ${
      isActive ? "active-tab" : "font-primary-color"
    } tab-border-bottom`;
  };

  const renderInventoryContent = () => {
    if (activeTab === 0) {
      return (
        <div>
          <p className="tw-text-sm font-gray-color tw-font-medium">
            My Tank Levels Content
          </p>
        </div>
      );
    }
    if (activeTab === 1) {
      return (
        <div>
          <p className="tw-text-sm font-gray-color tw-font-medium">
            Stock Dispensed Content
          </p>
        </div>
      );
    }
    return (
      <div>
        <p className="tw-text-sm font-gray-color tw-font-medium">
          Stock-in-Transit Content
        </p>
      </div>
    );
  };

  const getPercentageOfDocumentsApproved = () => {
    try {
      const percentage = Math.round(
        (userData?.approved_document_count / userData?.total_document_count) *
          100,
      );
      return percentage;
    } catch (error) {
      console.error("Error fetching percentage of documents approved:", error);
      return 0;
    }
  };

  const handleRedirectToProfile = () => {
    const isCompanyDetailAvailable = userData?.companies?.[0]?.id;
    if (
      !isCompanyDetailAvailable ||
      userData?.status === UserManagementStatus.R1
    ) {
      navigate(`/complete-profile`);
    } else {
      const currentPathName = window.location.pathname;
      navigate(`/t4/onboarding-profile?from=${currentPathName}`);
    }
  };

  return (
    <div className="tw-pb-10">
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-6 tw-bg-[#F8FAFC]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <h1 className="tw-text-[22px] tw-font-semibold font-primary-color">
                Dashboard
              </h1>
            </div>
            <div className="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
              {/* <button className="tw-flex tw-items-center tw-gap-2 tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button">
                <img
                  src={SupportIcon}
                  alt="support Icon"
                  className="tw-w-5 tw-h-5"
                />
                Support
              </button> */}
              {userData?.status > ProfileApprovalStatus.BR &&
                userData?.status !== ProfileApprovalStatus.R && (
                  <>
                    <button
                      onClick={() => navigate("/menu")}
                      className="tw-gap-2 tw-text-white tw-rounded-md primary-custom-button"
                    >
                      Go to Menu
                    </button>
                  </>
                )}
            </div>
          </div>
        </div>
      </div>

      <div className="tw-container-fluid tw-mx-auto tw-mt-[175px] tw-px-8">
        <div className="tw-grid tw-gap-2">
          {" "}
          {/* remove tw-gap-2 when only one message is there */}
          {userData?.status === UserManagementStatus.BR && (
            <div className="tw-bg-[#CBE5FF] tw-rounded-[10px] tw-p-4 tw-cursor-pointer">
              <p className="font-blue-dark-color font-size-sm tw-font-medium font-primary">
                <b>Pending</b> - Your account is under process for approval
              </p>
            </div>
          )}
          {(userData?.status === UserManagementStatus.FP ||
            userData?.status === UserManagementStatus.R2 ||
            userData?.status === UserManagementStatus.R1) && (
            <div
              className={`${userData?.status === UserManagementStatus.FP ? "tw-bg-[#D4EDDA] tw-border-[#C3E6CB]" : "tw-bg-[#FFD7D7] tw-border-[#FFD7D7]"} tw-rounded-[10px] tw-px-4 tw-py-2`}
            >
              <div className="tw-flex tw-justify-between tw-items-center">
                <p
                  className={`${userData?.status === UserManagementStatus.FP ? "font-green-dark-color" : "font-red-dark-color"} font-size-sm tw-font-medium font-primary`}
                >
                  {(userData?.status === UserManagementStatus.R1 ||
                    userData?.status === UserManagementStatus.R2) && (
                    <>
                      <b>Rejected</b> - Your account has been rejected.
                    </>
                  )}
                  {userData?.status === UserManagementStatus.FP && (
                    <>
                      Your Blitz Onboarding has been Approved. Now you need to{" "}
                      <b className="tw-text-[#0B2E13]">complete your profile</b>
                    </>
                  )}
                  {userData &&
                    userData.user_type.id === UserTierType.Tier4 &&
                    userData?.status !== UserManagementStatus.R1 &&
                    userData?.status !== UserManagementStatus.R2 && (
                      <>
                        {" "}
                        and{" "}
                        <b className="tw-text-[#0B2E13]">upload documents.</b>
                      </>
                    )}
                </p>
                <button
                  onClick={() => handleRedirectToProfile()}
                  className={`${userData?.status === UserManagementStatus.FP ? "tw-bg-[#155724]" : "tw-bg-[#B92C28]"} tw-text-white tw-rounded-lg tw-px-4 tw-py-2 tw-font-semibold font-size-sm`}
                >
                  {userData && userData.user_type.id === UserTierType.Tier4
                    ? "Upload Profile"
                    : "Complete Profile"}
                </button>
              </div>
            </div>
          )}
          {userData &&
            userData.user_type.id === UserTierType.Tier4 &&
            userData.status === UserManagementStatus.FR && (
              <>
                <div className="tw-bg-[#D0EDF1] tw-rounded-[10px] tw-px-4 tw-py-2">
                  <div className="tw-flex tw-justify-between tw-items-center">
                    <p className="tw-text-[#0D5560] font-size-sm tw-font-medium font-primary">
                      The document has been uploaded
                      <span>
                        {getPercentageOfDocumentsApproved() ? " and" : ""}
                      </span>
                      <b className="tw-text-[#062B32]">
                        {getPercentageOfDocumentsApproved()
                          ? ` ${getPercentageOfDocumentsApproved()}% has been approved.`
                          : "."}
                      </b>
                    </p>
                    <button
                      onClick={() => {
                        const currentPathName = window.location.pathname;
                        navigate(
                          `/t4/view-onboarding-documents?from=${currentPathName}`,
                        );
                      }}
                      className="tw-bg-[#0D5560] tw-text-white tw-rounded-lg tw-px-4 tw-py-2 tw-font-semibold font-size-sm"
                    >
                      Check Status
                    </button>
                  </div>
                </div>
                <div className="tw-bg-[#CEE2FE] tw-rounded-[10px] tw-px-4 tw-py-2">
                  <div className="tw-flex tw-justify-between tw-items-center">
                    <p className="tw-text-[#3A67B0] font-size-sm tw-font-medium font-primary">
                      Open the files timeline.
                    </p>
                    <button
                      onClick={() => {
                        const currentPathName = window.location.pathname;
                        navigate(
                          `/t4/view-onboarding-documents-timeline?from=${currentPathName}`,
                        );
                      }}
                      className="tw-bg-[#3A67B0] tw-text-white tw-rounded-lg tw-px-4 tw-py-2 tw-font-semibold font-size-sm"
                    >
                      Show
                    </button>
                  </div>
                </div>
              </>
            )}
        </div>
        <div className="tw-grid tw-grid-cols-8 tw-gap-4 tw-mt-5">
          <div className="tw-bg-white tw-col-span-2 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    My Profiles
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body tw-bg-gray-100">
                <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                  NO DATA AVAILABLE
                </div>
                {/* <div>
                  <h2 className="font-size-sm tw-text-[#809199] tw-mb-3 tw-font-normal">
                    Companies linked to my profile
                  </h2>
                  {companies.map((company) => (
                    <div
                      key={company.name}
                      className={`tw-flex tw-items-center tw-p-3 tw-rounded-lg tw-cursor-pointer tw-my-4 tw-border tw-border-[#E9EAEB] ${
                        selectedCompany === company.name
                          ? "tw-bg-[#ECFDF3] tw-border tw-border-[#E9EAEB] tw-text-[#027A48]"
                          : "tw-bg-white hover:tw-bg-gray-100 tw-text-[#027A48]"
                      }`}
                      onClick={() => setSelectedCompany(company.name)}
                    >
                      <img
                        src={company.icon}
                        className="tw-mr-3"
                        alt={`${company.name} logo`}
                      />
                      <span className="tw-flex-1 tw-ml-2 tw-text-[#232323]">
                        {company.name}
                      </span>
                      {selectedCompany === company.name && (
                        <img src={greencheck} alt="Green Check" />
                      )}
                    </div>
                  ))}
                </div> */}
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Switch Login
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-3 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Notifications & Support Center
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body tw-bg-gray-100 tw-h-[215px]">
                <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                  NO DATA AVAILABLE
                </div>
              </div>
              {/* <div className="custom-card-body !tw-p-0">
                <div className="tw-flex tw-flex-col">
                  <div className="tw-border-b tw-border-[#E9EAEB]">
                    <div className="tw-w-fit tw-mt-4">
                      <StyledTabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                      >
                        <StyledTab
                          label="System Notifications"
                          className={getTabClassName(activeTab === 0)}
                        />
                        <StyledTab
                          label="Support Desk Ticket"
                          className={getTabClassName(activeTab === 1)}
                        />
                      </StyledTabs>
                    </div>
                  </div>
                  <div>
                    <div className="system-notifications-content tw-h-[215px] tw-overflow-y-auto">
                      <div className="tw-border-b tw-border-gray-200 tw-py-4 tw-px-4">
                        <p className="tw-text-[#535862] font-size-sm font-primary">
                          <span className="tw-text-[#535862]">
                            Invoice #12345:{" "}
                          </span>
                          <span className="tw-font-bold font-primary-color">
                            R 5,000 000
                          </span>
                          <span className="tw-text-[#535862]">
                            {" "}
                            overdue since{" "}
                          </span>
                          <span className="tw-font-bold font-primary-color">
                            March 1, 2024
                          </span>
                          <span className="tw-text-[#535862]">.</span>
                        </p>
                      </div>

                      <div className="tw-border-b tw-border-gray-200 tw-py-4 tw-px-4">
                        <p className="tw-text-[#535862] font-size-sm font-primary">
                          <span className="tw-text-[#535862]">
                            Onboarding request for{" "}
                          </span>
                          <span className="tw-font-bold font-primary-color">
                            Caltex Oil
                          </span>
                          <span className="tw-text-[#535862]">
                            {" "}
                            is pending admin approval.
                          </span>
                        </p>
                      </div>

                      <div className="tw-border-b tw-border-gray-200 tw-py-4 tw-px-4">
                        <p className="tw-text-[#535862] font-size-sm font-primary">
                          <span className="tw-text-[#535862]">Your </span>
                          <span className="tw-font-bold font-primary-color">
                            Software License
                          </span>
                          <span className="tw-text-[#535862]">
                            {" "}
                            expires on{" "}
                          </span>
                          <span className="tw-font-bold font-primary-color">
                            March 31, 2024
                          </span>
                          <span className="tw-text-[#535862]">.</span>
                        </p>
                      </div>

                      <div className="tw-py-4 tw-px-4">
                        <p className="tw-text-[#535862] font-size-sm font-primary">
                          <span className="tw-text-[#535862]">
                            Downtime scheduled for{" "}
                          </span>
                          <span className="tw-font-bold font-primary-color">
                            March 20, 2024
                          </span>
                          <span className="tw-text-[#535862]"> </span>
                          <span className="tw-text-[#535862]">
                            (12:00 AM - 3:00 AM)
                          </span>
                          <span className="tw-text-[#535862]">.</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Review Notifications
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-3 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Recent Trades
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body tw-bg-gray-100">
                <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                  NO DATA AVAILABLE
                </div>
                {/* <div className="tw-grid tw-grid-cols-2 tw-gap-6">
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      sdasdasd
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      sdasdasd
                    </p>
                  </div>
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      sdasdasd
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      sdasdasd
                    </p>
                  </div>
                </div> */}
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Go to Trades
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-4 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Portfolio Reports
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body tw-bg-gray-100 tw-h-[215px]">
                <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                  NO DATA AVAILABLE
                </div>
                {/* <h2 className="font-size-sm tw-text-[#809199] tw-mb-3 tw-font-normal">
                  Wholesale Clients
                </h2>
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-h-[230px] tw-overflow-y-auto">
                  <div className="tw-bg-white tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-[#E9EAEB]">
                    <div className="tw-w-8 tw-h-8">
                      <img
                        src={ClientIcon}
                        alt="Client Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <span className="font-primary-color font-size-sm tw-font-medium">
                      Amina Yusuf
                    </span>
                  </div>

                  <div className="tw-bg-white tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-[#E9EAEB]">
                    <div className="tw-w-8 tw-h-8">
                      <img
                        src={ClientIcon}
                        alt="Client Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <span className="font-primary-color font-size-sm tw-font-medium">
                      Kwame Mensah
                    </span>
                  </div>

                  <div className="tw-bg-white tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-[#E9EAEB]">
                    <div className="tw-w-8 tw-h-8">
                      <img
                        src={ClientIcon}
                        alt="Client Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <span className="font-primary-color font-size-sm tw-font-medium">
                      Zuri Okafor
                    </span>
                  </div>
                  <div className="tw-bg-white tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-[#E9EAEB]">
                    <div className="tw-w-8 tw-h-8">
                      <img
                        src={ClientIcon}
                        alt="Client Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <span className="font-primary-color font-size-sm tw-font-medium">
                      Fatima Diallo
                    </span>
                  </div>
                  <div className="tw-bg-white tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-[#E9EAEB]">
                    <div className="tw-w-8 tw-h-8">
                      <img
                        src={ClientIcon}
                        alt="Client Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <span className="font-primary-color font-size-sm tw-font-medium">
                      Chike Nwosu
                    </span>
                  </div>
                  <div className="tw-bg-white tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-[#E9EAEB]">
                    <div className="tw-w-8 tw-h-8">
                      <img
                        src={ClientIcon}
                        alt="Client Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <span className="font-primary-color font-size-sm tw-font-medium">
                      Safiya Abebe
                    </span>
                  </div>
                  <div className="tw-bg-white tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-[#E9EAEB]">
                    <div className="tw-w-8 tw-h-8">
                      <img
                        src={ClientIcon}
                        alt="Client Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <span className="font-primary-color font-size-sm tw-font-medium">
                      Jabari Kamau
                    </span>
                  </div>
                  <div className="tw-bg-white tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-[#E9EAEB]">
                    <div className="tw-w-8 tw-h-8">
                      <img
                        src={ClientIcon}
                        alt="Client Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <span className="font-primary-color font-size-sm tw-font-medium">
                      Nia Adebayo
                    </span>
                  </div>
                  <div className="tw-bg-white tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-[#E9EAEB]">
                    <div className="tw-w-8 tw-h-8">
                      <img
                        src={ClientIcon}
                        alt="Client Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <span className="font-primary-color font-size-sm tw-font-medium">
                      Tariq Ndlovu
                    </span>
                  </div>
                </div> */}
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Go to Portfolio Reports
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-4 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Financial Covenants
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body tw-bg-gray-100">
                <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                  NO DATA AVAILABLE
                </div>
                {/* <div className="tw-grid tw-grid-cols-2 tw-gap-6">
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      sdasdasd
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      sdasdasd
                    </p>
                  </div>
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      sdasdasd
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      sdasdasd
                    </p>
                  </div>
                </div> */}
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Go to Covenants
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-4 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Inventory & Stock Management
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body !tw-p-0">
                <div className="tw-flex tw-flex-col">
                  <div className="tw-border-b tw-border-[#E9EAEB]">
                    <div className="tw-w-fit tw-mt-4">
                      <StyledTabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                      >
                        <StyledTab
                          label="My Tank Levels"
                          className={getTabClassName(activeTab === 0)}
                        />
                        <StyledTab
                          label="Stock Dispensed"
                          className={getTabClassName(activeTab === 1)}
                        />
                        <StyledTab
                          label="Stock-in-Transit (S.I.T)"
                          className={getTabClassName(activeTab === 2)}
                        />
                      </StyledTabs>
                    </div>
                  </div>
                  <div className="custom-card-body tw-bg-gray-100 tw-h-[215px]">
                    <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                      NO DATA AVAILABLE
                    </div>
                  </div>
                  {/* <div className="tw-grid tw-grid-cols-2 tw-gap-6 tw-p-4">
                    {renderInventoryContent()}
                  </div> */}
                </div>
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Go to Tanks
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-4 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Financial Overview
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body !tw-p-0">
                <div className="tw-flex tw-flex-col">
                  <div className="tw-border-b tw-border-[#E9EAEB]">
                    <div className="tw-w-fit tw-mt-4">
                      <StyledTabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                      >
                        <StyledTab
                          label="Bank Balance"
                          className={getTabClassName(activeTab === 0)}
                        />
                        <StyledTab
                          label="Payments Received"
                          className={getTabClassName(activeTab === 1)}
                        />
                        <StyledTab
                          label="Payments Made"
                          className={getTabClassName(activeTab === 2)}
                        />
                      </StyledTabs>
                    </div>
                  </div>
                  <div className="custom-card-body tw-bg-gray-100 tw-h-[215px]">
                    <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                      NO DATA AVAILABLE
                    </div>
                  </div>
                  {/* <div className="tw-grid tw-grid-cols-2 tw-gap-6 tw-p-4">
                    {activeTab === 0 ? (
                      <>
                        <div>
                          <p className="tw-text-sm font-gray-color tw-font-medium">
                            Current Balance
                          </p>
                          <p className="tw-font-medium font-primary-color tw-mt-1">
                            R 250,000.00
                          </p>
                        </div>
                        <div>
                          <p className="tw-text-sm font-gray-color tw-font-medium">
                            Available Balance
                          </p>
                          <p className="tw-font-medium font-primary-color tw-mt-1">
                            R 200,000.00
                          </p>
                        </div>
                      </>
                    ) : activeTab === 1 ? (
                      <>
                        <div>
                          <p className="tw-text-sm font-gray-color tw-font-medium">
                            Today's Received
                          </p>
                          <p className="tw-font-medium font-primary-color tw-mt-1">
                            R 25,000.00
                          </p>
                        </div>
                        <div>
                          <p className="tw-text-sm font-gray-color tw-font-medium">
                            Total Received
                          </p>
                          <p className="tw-font-medium font-primary-color tw-mt-1">
                            R 75,000.00
                          </p>
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          <p className="tw-text-sm font-gray-color tw-font-medium">
                            Today's Payments
                          </p>
                          <p className="tw-font-medium font-primary-color tw-mt-1">
                            R 45,000.00
                          </p>
                        </div>
                        <div>
                          <p className="tw-text-sm font-gray-color tw-font-medium">
                            Total Payments
                          </p>
                          <p className="tw-font-medium font-primary-color tw-mt-1">
                            R 125,000.00
                          </p>
                        </div>
                      </>
                    )}
                  </div> */}
                </div>
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Go to Feed
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-5 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Petroleum Data | South Africa
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body tw-bg-gray-100 tw-h-[215px]">
                <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                  NO DATA AVAILABLE
                </div>
                {/* <div className="tw-grid tw-grid-cols-3 tw-gap-6">
                  <div className="tw-bg-[#EEF2FF] tw-border tw-border-[#E9EAEB] tw-p-4 tw-rounded-2xl">
                    <h3 className="tw-text-[#312E81] tw-text-sm tw-font-medium tw-mb-3">
                      Fuel Statistics
                    </h3>
                    <div className="tw-flex tw-flex-col tw-gap-4 tw-h-[320px] tw-overflow-y-auto">
                      <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-p-4 tw-rounded-xl tw-flex tw-justify-between tw-items-center">
                        <span className="tw-text-sm tw-font-semibold">
                          Petroleum
                        </span>
                        <div className="tw-flex tw-items-center tw-gap-3">
                          <span className="tw-font-normal tw-text-sm">
                            R20.68
                          </span>
                          <span className="tw-text-sm tw-text-medium tw-bg-[#FF3B3038] tw-min-w-[70px] tw-text-center tw-text-[#B54708] tw-px-2 tw-py-2 tw-rounded-md">
                            + 0.83%
                          </span>
                        </div>
                      </div>

                      <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-p-4 tw-rounded-xl tw-flex tw-justify-between tw-items-center">
                        <span className="tw-text-sm tw-font-semibold">
                          Diesel
                        </span>
                        <div className="tw-flex tw-items-center tw-gap-3">
                          <span className="tw-font-normal tw-text-sm">
                            R17.87
                          </span>
                          <span className="tw-text-sm tw-text-medium tw-bg-[#B8FFD6] tw-min-w-[70px] tw-text-center tw-text-[#027A48] tw-px-2 tw-py-1 tw-rounded-md">
                            - 1%
                          </span>
                        </div>
                      </div>

                      <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-p-4 tw-rounded-xl tw-flex tw-justify-between tw-items-center">
                        <span className="tw-text-sm tw-font-semibold">Gas</span>
                        <div className="tw-flex tw-items-center tw-gap-3">
                          <span className="tw-font-normal tw-text-sm">
                            R21.05
                          </span>
                          <span className="tw-text-sm tw-text-medium tw-bg-[#FF3B3038] tw-min-w-[70px] tw-text-center tw-text-[#B54708] tw-px-2 tw-py-2 tw-rounded-md">
                            + 0.83%
                          </span>
                        </div>
                      </div>

                      <div className="tw-bg-white tw-p-4 tw-rounded-xl">
                        <span className="tw-text-lg tw-font-medium">
                          Other fuel types
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="tw-bg-[#F0FDFA] tw-p-4 tw-rounded-2xl tw-border tw-border-[#E9EAEB]">
                    <h3 className="tw-text-[#164E63] tw-text-sm tw-font-medium tw-mb-3">
                      Currency Rates Updated Daily
                    </h3>
                    <div className="tw-flex tw-flex-col tw-gap-4 tw-h-[320px] tw-overflow-y-auto">
                      <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-p-4 tw-rounded-xl tw-flex tw-justify-between tw-items-center">
                        <div className="tw-flex tw-items-center tw-gap-2">
                          <img
                            src={UsdIcon}
                            alt="USA"
                            className="tw-w-6 tw-h-6 tw-rounded-full"
                          />
                          <span className="tw-text-sm tw-font-semibold">
                            USD
                          </span>
                        </div>
                        <span className="tw-font-normal tw-text-sm">
                          R17.87
                        </span>
                        <span className="tw-text-sm tw-text-medium tw-bg-[#FF3B3038] tw-min-w-[70px] tw-text-center tw-text-[#B54708] tw-px-2 tw-py-2 tw-rounded-md">
                          + 0.57%
                        </span>
                      </div>

                      <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-p-4 tw-rounded-xl tw-flex tw-justify-between tw-items-center">
                        <div className="tw-flex tw-items-center tw-gap-2">
                          <img
                            src={EuroIcon}
                            alt="Euro"
                            className="tw-w-6 tw-h-6 tw-rounded-full"
                          />
                          <span className="tw-text-sm tw-font-semibold">
                            Euro
                          </span>
                        </div>
                        <span className="tw-font-normal tw-text-sm">
                          R18.75
                        </span>
                        <span className="tw-text-sm tw-text-medium tw-bg-[#B8FFD6] tw-min-w-[70px] tw-text-center tw-text-[#027A48] tw-px-2 tw-py-1 tw-rounded-md">
                          - 1.3%
                        </span>
                      </div>

                      <div className="tw-bg-white tw-p-4 tw-rounded-xl tw-border tw-border-[#E9EAEB]">
                        <span className="tw-text-sm tw-font-semibold">Etc</span>
                      </div>
                    </div>
                  </div>

                  <div className="tw-bg-[#FFF7ED] tw-p-4 tw-rounded-2xl tw-border tw-border-[#E9EAEB]">
                    <h3 className="tw-text-[#7C2D12] tw-text-sm tw-font-medium tw-mb-3">
                      Industry Announcements
                    </h3>
                    <div className="tw-flex tw-flex-col tw-gap-4 tw-h-[320px] tw-overflow-y-auto">
                      <div className="tw-bg-white tw-p-4 tw-rounded-xl tw-border tw-border-[#E9EAEB]">
                        <p className="tw-text-sm tw-font-medium tw-mb-2">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                        <a
                          href="/"
                          className="tw-text-[#146C94] tw-w-fit tw-flex tw-items-center tw-gap-2 tw-mt-2"
                        >
                          <img
                            src={LinkIcon}
                            alt="Link Icon"
                            className="tw-w-[18px] tw-h-[18px]"
                          />
                          Read more
                        </a>
                      </div>

                      <div className="tw-bg-white tw-p-4 tw-rounded-xl tw-border tw-border-[#E9EAEB]">
                        <p className="tw-text-sm tw-font-medium tw-mb-2">
                          Lorem Ipsum has been the industry's standard dummy
                          text ever since the 1500s,
                        </p>
                        <a
                          href="/"
                          className="tw-text-[#146C94] tw-w-fit tw-flex tw-items-center tw-gap-2 tw-mt-2"
                        >
                          <img
                            src={LinkIcon}
                            alt="Link Icon"
                            className="tw-w-[18px] tw-h-[18px]"
                          />
                          Read more
                        </a>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Go to Feed
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-3 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Petroleum Grid Pricing
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body tw-bg-gray-100">
                <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                  NO DATA AVAILABLE
                </div>
                {/* <div className="tw-grid tw-grid-cols-2 tw-gap-6">
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      sdasdasd
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      sdasdasd
                    </p>
                  </div>
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      sdasdasd
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      sdasdasd
                    </p>
                  </div>
                </div> */}
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Go to Grid
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-3 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Documents
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body tw-bg-gray-100">
                <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                  NO DATA AVAILABLE
                </div>
                {/* <div className="custom-card-body !tw-pb-0">
                <div className="documents-container tw-flex tw-flex-col tw-gap-4 tw-h-[370px] tw-overflow-y-auto">
                  <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-justify-between tw-cursor-pointer hover:tw-bg-gray-50">
                    <div className="tw-flex tw-items-center tw-gap-4">
                      <div className="tw-text-gray-500">
                        <img
                          src={DocumentsIcon}
                          alt="Documents Icon"
                          className="tw-w-6 tw-h-6"
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <h3 className="tw-text-[16px] tw-font-medium font-primary-color tw-mb-2">
                          POPI Act Agreement
                        </h3>
                        <p className="tw-text-[14px] tw-text-[#809199]">
                          Jan 8, 2024, 10:30 AM
                        </p>
                      </div>
                    </div>
                    <div className="tw-text-[#0066CC]">
                      <img
                        src={RightArrowIcon}
                        alt="Right Arrow Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                  </div>

                  <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-justify-between tw-cursor-pointer hover:tw-bg-gray-50">
                    <div className="tw-flex tw-items-center tw-gap-4">
                      <div className="tw-text-gray-500">
                        <img
                          src={DocumentsIcon}
                          alt="Documents Icon"
                          className="tw-w-6 tw-h-6"
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <h3 className="tw-text-[16px] tw-font-medium font-primary-color tw-mb-2">
                          iBanq System Agreement
                        </h3>
                        <p className="tw-text-[14px] tw-text-[#809199]">
                          Jan 8, 2024, 10:30 AM
                        </p>
                      </div>
                    </div>
                    <div className="tw-text-[#0066CC]">
                      <img
                        src={RightArrowIcon}
                        alt="Right Arrow Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                  </div>

                  <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-justify-between tw-cursor-pointer hover:tw-bg-gray-50">
                    <div className="tw-flex tw-items-center tw-gap-4">
                      <div className="tw-text-gray-500">
                        <img
                          src={DocumentsIcon}
                          alt="Documents Icon"
                          className="tw-w-6 tw-h-6"
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <h3 className="tw-text-[16px] tw-font-medium font-primary-color tw-mb-2">
                          Collateral Management Agreement
                        </h3>
                        <p className="tw-text-[14px] tw-text-[#809199]">
                          Jan 8, 2024, 10:30 AM
                        </p>
                      </div>
                    </div>
                    <div className="tw-text-[#0066CC]">
                      <img
                        src={RightArrowIcon}
                        alt="Right Arrow Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                  </div>

                  <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-justify-between tw-cursor-pointer hover:tw-bg-gray-50">
                    <div className="tw-flex tw-items-center tw-gap-4">
                      <div className="tw-text-gray-500">
                        <img
                          src={DocumentsIcon}
                          alt="Documents Icon"
                          className="tw-w-6 tw-h-6"
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <h3 className="tw-text-[16px] tw-font-medium font-primary-color tw-mb-2">
                          Omart Guarantor Agreement
                        </h3>
                        <p className="tw-text-[14px] tw-text-[#809199]">
                          Jan 8, 2024, 10:30 AM
                        </p>
                      </div>
                    </div>
                    <div className="tw-text-[#0066CC]">
                      <img
                        src={RightArrowIcon}
                        alt="Right Arrow Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                  </div>

                  <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-justify-between tw-cursor-pointer hover:tw-bg-gray-50">
                    <div className="tw-flex tw-items-center tw-gap-4">
                      <div className="tw-text-gray-500">
                        <img
                          src={DocumentsIcon}
                          alt="Documents Icon"
                          className="tw-w-6 tw-h-6"
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <h3 className="tw-text-[16px] tw-font-medium font-primary-color tw-mb-2">
                          Omart Guarantor Agreement
                        </h3>
                        <p className="tw-text-[14px] tw-text-[#809199]">
                          Jan 8, 2024, 10:30 AM
                        </p>
                      </div>
                    </div>
                    <div className="tw-text-[#0066CC]">
                      <img
                        src={RightArrowIcon}
                        alt="Right Arrow Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                  </div>
                  <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-justify-between tw-cursor-pointer hover:tw-bg-gray-50">
                    <div className="tw-flex tw-items-center tw-gap-4">
                      <div className="tw-text-gray-500">
                        <img
                          src={DocumentsIcon}
                          alt="Documents Icon"
                          className="tw-w-6 tw-h-6"
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <h3 className="tw-text-[16px] tw-font-medium font-primary-color tw-mb-2">
                          Omart Guarantor Agreement
                        </h3>
                        <p className="tw-text-[14px] tw-text-[#809199]">
                          Jan 8, 2024, 10:30 AM
                        </p>
                      </div>
                    </div>
                    <div className="tw-text-[#0066CC]">
                      <img
                        src={RightArrowIcon}
                        alt="Right Arrow Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                  </div>
                  <div className="tw-bg-white tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-justify-between tw-cursor-pointer hover:tw-bg-gray-50">
                    <div className="tw-flex tw-items-center tw-gap-4">
                      <div className="tw-text-gray-500">
                        <img
                          src={DocumentsIcon}
                          alt="Documents Icon"
                          className="tw-w-6 tw-h-6"
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <h3 className="tw-text-[16px] tw-font-medium font-primary-color tw-mb-2">
                          Omart Guarantor Agreement
                        </h3>
                        <p className="tw-text-[14px] tw-text-[#809199]">
                          Jan 8, 2024, 10:30 AM
                        </p>
                      </div>
                    </div>
                    <div className="tw-text-[#0066CC]">
                      <img
                        src={RightArrowIcon}
                        alt="Right Arrow Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Go to Documents
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white tw-col-span-5 custom-card-drag !tw-my-[0]">
            <div>
              <div className="custom-card-header">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <h3 className="font-size-base tw-font-semibold font-primary-color">
                    Communication Hub
                  </h3>
                  <img
                    src={DragIcon}
                    alt="Drag Icon"
                    className="tw-w-6 tw-h-6 tw-cursor-grab"
                  ></img>
                </div>
              </div>
              <div className="custom-card-body !tw-p-0">
                <div className="tw-flex tw-flex-col">
                  <div className="tw-border-b tw-border-[#E9EAEB]">
                    <div className="tw-w-fit tw-mt-4">
                      <StyledTabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                      >
                        <StyledTab
                          label="Contact Ibanq"
                          className={getTabClassName(activeTab === 0)}
                        />
                        <StyledTab
                          label="Contact My Client"
                          className={getTabClassName(activeTab === 1)}
                        />
                        <StyledTab
                          label="Contact My Supplier"
                          className={getTabClassName(activeTab === 2)}
                        />
                      </StyledTabs>
                    </div>
                  </div>
                  <div className="custom-card-body tw-bg-gray-100 tw-h-[215px]">
                    <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-gray-500 tw-font-semibold">
                      NO DATA AVAILABLE
                    </div>
                  </div>
                </div>
              </div>
              <div className="custom-card-footer">
                <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    Get in Touch Now
                  </button>
                  <button className="tw-text-[#146C94] tw-rounded-lg tw-font-medium font-size-base">
                    <img
                      src={RightArrowIcon}
                      alt="Right Arrow Icon"
                      className="tw-w-6 tw-h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {userData?.admin_details &&
        userData?.user_type.id !== UserTierType.Tier3 && (
          <div className="tw-fixed tw-bottom-0 tw-right-0 tw-p-4">
            <button
              onClick={() =>
                navigate(
                  `/live-chat?screen=user&id=${userData?.admin_details?.admin_id}&company_id=${userData?.admin_details?.company_id}`,
                )
              }
              className="tw-flex tw-items-center tw-gap-2 tw-rounded-full primary-custom-button-chat"
            >
              <img src={ChatIcon} alt="Chat Icon" className="tw-w-6 tw-h-6" />
              Live Chat
            </button>
          </div>
        )}
    </div>
  );
};

export default Dashboard;
